import { render, staticRenderFns } from "./SupporterViewEmails.vue?vue&type=template&id=81c1b6da&"
import script from "./SupporterViewEmails.vue?vue&type=script&lang=js&"
export * from "./SupporterViewEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81c1b6da')) {
      api.createRecord('81c1b6da', component.options)
    } else {
      api.reload('81c1b6da', component.options)
    }
    module.hot.accept("./SupporterViewEmails.vue?vue&type=template&id=81c1b6da&", function () {
      api.rerender('81c1b6da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Details/SupporterViewEmails.vue"
export default component.exports